'use client';

import type { FC } from 'react';

import { type IScFlipWrapper, ScFlipWrapper } from './styled';

export interface IFlipWrapper extends IScFlipWrapper {
  front: React.ReactNode;
  back: React.ReactNode;
}

export const FlipWrapper: FC<IFlipWrapper> = ({
  front,
  back,
  isFlipped,
  width,
  height,
}) => (
  <ScFlipWrapper height={height} isFlipped={isFlipped} width={width}>
    <div className="front">{front}</div>
    <div className="back">{back}</div>
  </ScFlipWrapper>
);
